// External libraries
import gql from 'graphql-tag';

export const CART_ITEMS_FRAGMENT = gql`
  fragment CartItems on Cart {
    items {
      description
      details
      name
      quantity
      total {
        currencyFormat
        currencyValue
      }
      unitPrice {
        currencyFormat
        currencyValue
      }
    }
  }
`;
